import React from 'react';
interface Props {
	title: string;
	children: React.ReactNode;
}
const RecruiterSupportCardWrapper = ({ title, children }: Props) => {
	return (
		<div className="rounded-[8px] border border-[#C7C9D9] ">
			<div className="rounded-tl-[8px] rounded-tr-[8px] bg-[#E5F0FF] p-[16px]">
				<p className="text-[16px] font-[500] leading-[24px] text-[#7777E7]">{title}</p>
			</div>

			{children}
		</div>
	);
};

export default RecruiterSupportCardWrapper;
